import { useGameStore } from '@/stores/game';
// import { Results } from '../../_misc/Results';
import AssetService from '@/services/AssetService';
import { urls } from '@/config/assets';
// import * as config from '@/config/games/beer';

export const GamePage = ({ show, ...props }) => {
  // const { t } = useTranslation();
  const { completed } = useAssetProgress();

  useEffect(() => {
    if (!show) return;
    let gameloop = AssetService.getAsset('mx_gameloop');
    if (gameloop) {
      gameloop.stop();
      gameloop.currentTime = 0;
      gameloop.loop = true;
      gameloop.play();
    }
  }, []);

  return (
    <div className={cn(['page', 'game'])}>{completed && <BeerGame />}</div>
  );
};
